export var cleanPartnerBasedPlatformNames = function (str) {
    return str
        .replace(' (Partnership)', '')
        .replace(' (OSV)', '')
        .replace(' (Test)', '')
        .replace(' (Demo)', '')
        .replace('Test iFrame', 'ADP')
        .replace('ADP Partnership Fallback Integration March 2024', 'ADP');
};
